export default "__VITE_ASSET__b4b5fcc1__"